import { cloudStorage } from '@telegram-apps/sdk';

type Data = string | number | boolean | object | unknown[];

const encode = (data: Data): string => {
  return typeof data === 'string' ? data : JSON.stringify(data);
};

export const setToStore = async (key: string, data: Data): Promise<void> => {
  if (!key) {
    throw new Error('Key is undefined!');
  }

  if (!cloudStorage.setItem?.isAvailable()) {
    throw new Error('Cloud storage is unavailable!');
  }

  try {
    await cloudStorage.setItem(key, encode(data));
  } catch (err) {
    console.error('[cloudStorage] setItem failed', err);
  }
};
